import { render } from "./Shop.vue?vue&type=template&id=854455d8&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=854455d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-854455d8"

export default script